import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class RemarkModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remark: ""
    }
  }

  componentDidMount() {
    const { remark } = this.props;
    let remarkText;

    if(remark.length > 0){
      remarkText = remark[0].value
    }

    this.setState({
      remark: remarkText
    });
  }

  handleOnClickSave = () => {
    const { onClickSave } = this.props;
    const { remark } = this.state;
    onClickSave([{ name: "remark", value: remark }], true);
  }

  handleOnClose = () => {
    const { onClose } = this.props;
    onClose();
  }

  handleOnInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  render() {
    const { item } = this.props;
    const { remark } = this.state;

    return (
      <Modal style={{top:'15%', border: 'none'}} show={true} onHide={this.handleOnClose}>
        <Modal.Header className="mx-2 mt-1" style={{borderBottom: 'none'}} closeButton>
            <h4 className="mb-0">Seller Remark</h4>
        </Modal.Header>
        <Modal.Body className="mx-4 px-0 py-4" style={{borderTop: '1px solid #dee2e6'}}>
          <form>
            <textarea className="form-control" id="remark" name="remark" placeholder="Enter remark" value={remark} onChange={this.handleOnInputChange}/>
          </form>
        </Modal.Body>
        <Modal.Footer className="pt-0" style={{borderTop: 'none'}}>
          <Button variant="danger-secondary" onClick={this.handleOnClose}>Cancel</Button>
          <Button variant="primary" onClick={this.handleOnClickSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RemarkModal;
